module.exports = __webpack_public_path__ + "img/retrospect-139.73a594aa.jpg";